/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Styles for LabeledOptionsMenu
 *
 * @author Gladson Samuel S
 * @file LabeledOptionsMenuStyles.js
 */

import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../assets/styles/mixins.scss';

const useLabeledOptionsMenuStyles = makeStyles({
  root: {
    display: 'inline-flex'
  },
  triggerButton: {
    textTransform: 'none',
    padding: '8px',
    borderRadius: 1000,
    color: '#0d004d',
    fontFamily: `${mixins.fontFamilyPlusSans}, sans-serif`,
    fontWeight: mixins.fontWeight500,
    fontSize: mixins.fontSize14,
    lineHeight: '22px',
    minWidth: 0,
    fontFeatureSettings: '\'liga\' off',
    '&:hover': {
      backgroundColor: 'rgba(13, 0, 77, 0.04)'
    }
  },
  triggerButtonLabel: {
    display: 'flex',
    gap: 8
  },
  startIconContainer: {
    margin: 0
  },
  endIconContainer: {
    margin: 0,
    marginLeft: 14
  },
  startIcon: {
    width: 16,
    height: 16,
    fontSize: 16,
    display: 'block'
  },
  endIcon: {
    width: 10,
    height: 6,
    fontSize: 10,
    display: 'block'
  },
  menuPaper: {
    border: '1px solid #3d1788',
    borderRadius: 4,
    backgroundColor: mixins.chalkWhiteFont,
    marginTop: 4,
    boxSizing: 'border-box'
  },
  menuList: {
    padding: 0
  },
  menuItem: {
    padding: 12,
    fontSize: mixins.fontSize16,
    lineHeight: '24px',
    color: '#2e2e2e',
    fontFamily: `${mixins.fontFamilyPlusSans}, sans-serif`,
    fontWeight: mixins.fontWeight400,
    fontFeatureSettings: '\'liga\' off',
    boxSizing: 'border-box'
  },
  menuItemSelected: {
    backgroundColor: '#e8e6f3',
    fontWeight: mixins.fontWeight600,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#e8e6f3'
    },
    '&.Mui-selected': {
      backgroundColor: '#e8e6f3'
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#e8e6f3'
    }
  },
  menuItemLabel: {
    flex: '1 1 auto',
    minWidth: 282
  },
  checkIcon: {
    width: 18,
    height: 18,
    fontSize: 18,
    marginLeft: 8,
    flexShrink: 0,
    display: 'block'
  }
});

export default useLabeledOptionsMenuStyles;
